import { Flex, FormItemsGroup, IconButton, Spacing, Text } from '@billy/design-system'
import { ReactElement, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useCustomerForm } from '../../contexts/customerFormContext'
import { CustomerOptionalItem } from '../../enums/customerOptionalItem'
import { getOptionalItems } from './utils/getOptionalItems'

export const OptionalItems = (): ReactElement | null => {
  const { t } = useTranslation()
  const { activeOptionalFormItems, removeOptionalFormItem } = useCustomerForm()

  const optionalItems = useMemo(() => getOptionalItems(), [])

  const isSectionHidden = activeOptionalFormItems.length === 0

  const handleRemoveButtonClick = useCallback(
    (item: CustomerOptionalItem) => {
      removeOptionalFormItem(item)
    },
    [removeOptionalFormItem],
  )

  if (isSectionHidden) {
    return null
  }

  return (
    <FormItemsGroup rowSpacing={Spacing.S12}>
      <Text variant="h4"> {t('customer_modal.form.optional_items.header')}</Text>
      {activeOptionalFormItems.map((item: CustomerOptionalItem) => {
        return (
          <FormItemsGroup itemsInRow={11} key={item}>
            {optionalItems[item]}
            <Flex alignItems="flex-end">
              <IconButton icon="trash" onClick={() => handleRemoveButtonClick(item)} size="md" variant="outlined" />
            </Flex>
          </FormItemsGroup>
        )
      })}
    </FormItemsGroup>
  )
}
